export default "__VITE_ASSET__5ad47de1__"